import { getFeature, isFeature } from 'Cloud/Application/FeaturesEs6';

/** id промо */
export const PROMO_ID = 'web-auto-upload-fakedoor';

export const enableWebAutoUploadFakedoor = isFeature(`enable-${PROMO_ID}`);
export const closeLimit: number = +getFeature(`${PROMO_ID}-close-limit`) || 1;
export const showLimit: number = +getFeature(`${PROMO_ID}-show-limit`) || 10;
